import { Container } from "react-bootstrap";
import React from "react";

function TermsOfUse() {
  return (
    <div className="body_container_wrapper home">
      <Container>
        <div className="termspolicy">
          <h4 className="text-center">HEALTHY PLANEAT TERMS OF USE</h4>
          <p className="text-center">
            <strong>Last Modified: November 26, 2025</strong>
          </p>

          <h6>Welcome to Healthyplaneat.com</h6>

          <p>
            These Terms of Use (the "<strong>Agreement</strong>") govern your
            use of the website located at healthyplaneat.com (the "
            <strong>Website</strong>") and all related products, services,
            tools, mobile applications, web applications, and any other
            technology platforms or tools located at any Sustainable Planet LLC
            (the "<strong>Company</strong>", "<strong>us</strong>", "
            <strong>we</strong>", or "<strong>our</strong>") websites, including
            without limitation, successor website(s) or application(s) thereto
            (collectively, the "<strong>Services</strong>"). The terms "
            <strong>you,</strong>" "<strong>your</strong>" or "
            <strong>user</strong>" refers to you, the user. If you are using the
            Services on behalf of a business, association, or other entity,
            "you" or "your" will also refer to such business, association, or
            other entity, unless the context clearly dictates otherwise. You
            agree that you are authorized to consent to these terms on behalf of
            such business, association, or other entity, and we can rely on
            this.
          </p>

          <h6>Important Notices</h6>

          <p>
            PLEASE READ THE AGREEMENT CAREFULLY, AS IT CONTAINS AN AGREEMENT TO
            ARBITRATE AND OTHER IMPORTANT INFORMATION REGARDING YOUR LEGAL
            RIGHTS, REMEDIES AND OBLIGATIONS. THE AGREEMENT TO ARBITRATE
            REQUIRES (WITH LIMITED EXCEPTION) THAT YOU SUBMIT CLAIMS YOU HAVE
            AGAINST US TO BINDING AND FINAL ARBITRATION, AND FURTHER (1) YOU
            WILL ONLY BE PERMITTED TO PURSUE CLAIMS AGAINST COMPANY ON AN
            INDIVIDUAL BASIS, NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS OR
            REPRESENTATIVE ACTION OR PROCEEDING, (2) YOU WILL ONLY BE PERMITTED
            TO SEEK RELIEF (INCLUDING MONETARY, INJUNCTIVE AND DECLARATORY
            RELIEF) ON AN INDIVIDUAL BASIS, AND (3) YOU MAY NOT BE ABLE TO HAVE
            ANY CLAIMS YOU HAVE AGAINST US RESOLVED BY A JURY OR IN A COURT OF
            LAW
            <strong>
              <em>.</em>
            </strong>
          </p>

          <h6>
            <strong>1. Acceptance of this Agreement</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>1.1. Acceptance Through Using or Accessing the Services</em>
              </strong>
              <strong>. </strong>Please review the Agreement very carefully
              before accessing or using our Services. By clicking on "accept" or
              "agree" to this Agreement when prompted or using/ continuing to
              use our Services, you acknowledge you have read and understand and
              agree to be bound by the terms and conditions of this Agreement,
              including those additional terms and conditions and policies
              referenced herein and/or available by hyperlink. Please print a
              copy of this Agreement for your records. If you do not agree to
              all the terms and conditions of this Agreement, then you may not
              use or access any Services. If this Agreement is considered an
              offer, acceptance is expressly limited to this Agreement.
            </p>

            <p>
              <strong>
                <em>
                  1.2. Eligibility Requirements to Use or Access the Services
                </em>
              </strong>
              <strong>. </strong>To use the Services you must be, and represent
              and warrant that: (i) you are (a) at least the age of majority in
              your state, province or jurisdiction of residence, and (b) a
              resident of the United States; (ii) you have all necessary rights,
              power, authority, and capacity to enter into this Agreement and
              perform your obligations hereunder; and (iii) nothing contained in
              this Agreement or in the performance of such obligations will
              place you in breach of any other contract or obligation.
            </p>

            <p>
              <strong>
                <em>1.3. Geographic Restrictions</em>
              </strong>
              <strong>.</strong> Company is based in the United States, and the
              Services are offered for use only to persons located in the United
              States. You represent and warrant to Company that by choosing to
              access and use the Services you are located in the United States.
              In the event you are not located in the United State, please
              immediately stop using the Services. Company makes no
              representations or warranties that the Services or any of its
              content are accessible, appropriate, or in compliance with any
              laws or regulations outside of the United States. For clarity and
              the avoidance of doubt, Company is a United States domestic
              organization and does not avail itself of the laws of any foreign
              (non-United States) jurisdiction, including, but not limited to,
              the European Union and the General Data Protection Regulation ("
              <strong>GDPR</strong>").
            </p>

            <p>
              <strong>
                <em>1.4. Privacy Policy</em>
              </strong>
              <strong>.</strong> Please refer to our{" "}
              <a href="https://healthyplaneat.com/privacypolicy">
                Privacy Policy
              </a>{" "}
              for information about how we collect, use, store, and disclose
              your personal information.
            </p>
          </div>

          <h6>
            <strong>2. The Services</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>2.1. The Services</em>
              </strong>
              <strong>.</strong> The Services offers services to three types of
              users: (i) if you are selling products through our Services (e.g.,
              a farmer) ("<strong>Seller</strong>"); (ii) if you are purchasing
              products through the Services (e.g., an individual consumer) ("
              <strong>Buyer</strong>"); and (iii) if you are facilitating the
              aggregation, storage, processing and/or distribution of
              locally/regionally produced food products (e.g., Pick-up Event
              Host (as defined in Section 4.1.8), Delivery Providers (as defined
              in Section 4.3) food hub, or food aggregator) ("
              <strong>Distribution Provider</strong>"). The Services provide a
              venue for (a) Buyers to discover and purchase healthy and
              sustainable food from Sellers and (b) Distribution Providers to
              facilitate the purchase and sale of healthy and sustainable food
              with Buyers and Sellers. Depending on the context of their
              activities, Distribution Providers may be considered a "Seller"
              and/or "Buyer" or "Pick-up Event Host" for purposes of this
              Agreement. Please note that we are not a part of that Buyer-Seller
              transaction. By using the Services you are not buying directly
              from us, but from one of the many Sellers who use the Services,
              and therefore Company is not liable for any damages or loss as it
              relates to such buying activities. For example, a Distribution
              Provider may have entered into a separate agreement with a Seller
              for the purchase of food, but such Distribution Provider and
              Seller may utilize the Services to facilitate the distribution of
              the food; in such instance you are not buying directly from us.
            </p>

            <p>
              Though we may pre-screen Sellers, we do not represent or warrant,
              guarantee, or endorse any products sold on the Services or any
              content posted by Sellers (such as photographs or language used in
              listings or shop policies). Images of products on the Services are
              examples only and may not be identical to the product you receive
              from a Seller. Any difference may be due to your device's display
              of colors or factors such as the Seller, the area of the Seller's
              operation, and the season of the year. We reserve the right, but
              are not obligated, to limit the sales of our Services to any
              person, geographic region, or jurisdiction. We may exercise this
              right on a case-by-case basis, in our sole discretion. We reserve
              the right to limit the quantities of any Services that we offer.
              All descriptions of Services are subject to change at any time
              without notice, at the sole discretion of us. We reserve the right
              to modify, withdraw, or discontinue the Services, in whole or in
              part, at any time without notice to you. You agree that the
              Company shall have no liability to you or any third party for any
              losses or damages caused by the Services not being available, in
              whole or in part, at any time or for any period of time. Any offer
              for any Service is void where prohibited.
            </p>

            <p>
              <strong>
                <em>2.2. Errors, Inaccuracies, and Omissions</em>
              </strong>
              <strong>.</strong> Occasionally there may be information on the
              Services that contains typographical errors, inaccuracies, or
              omissions that may relate to Services' descriptions, pricing,
              promotions, offers, Services shipping charges, transit times, and
              availability. We reserve the right, without prior notice, to (i)
              correct any errors, inaccuracies, or omissions, and (ii) change or
              update information or cancel orders, if any information in the
              Services or on any related website is inaccurate at any time
              (including after you have submitted your order).
            </p>

            <p>
              We undertake no obligation to update, amend, or clarify
              information in the Services or on any related website, including
              without limitation, pricing information, except as required by
              law. No specified update or refresh date applied in the Services
              or on any related website, should be taken to indicate that all
              information in the Services or on any related website has been
              modified or updated.
            </p>

            <p>
              <strong>
                <em>2.3. Third-Party Websites and Providers</em>
              </strong>
              <strong>.</strong> Certain content, products, and services
              available via the Services may be provided by third parties,
              include materials from third-parties or provide you with access to
              third-party tools, services, products, and resources over which we
              neither monitor nor have any control nor input. Further,
              third-party links on our Website may direct you to third-party
              websites that are not affiliated with us. We are not responsible
              for examining or evaluating the content or accuracy of any
              third-party materials or websites, or for any other materials,
              products, or services of third-parties. The ideas, opinions and
              views expressed by third parties utilizing the Services or in
              third-party materials, websites, resources, products, or services
              are those of such third-party, and do not necessarily reflect our
              views of the view of other users of the Services.
            </p>

            <p>
              You acknowledge and agree that we provide access to such
              materials, products, websites, tools, and resources "as is" and
              "as available" without any warranties, representations, or
              conditions of any kind and without any endorsement. We do not
              warrant and will not have any liability or responsibility arising
              from or relating to third-party materials, websites, tools,
              products, and resources. Any use by you of third-party materials,
              tools, products, services, and resources offered through the
              Services is entirely at your own risk and discretion and you
              should ensure that you are familiar with and approve of the terms
              on which such items are provided by the relevant third-party
              provider(s). If you connect to the Services via a third-party
              service or website, you grant us permission to access and use your
              information from such service or website, as permitted by that
              service, to store your login credentials for that service.
            </p>

            <p>
              We are not liable for any harm or damages related to the purchase
              or use of goods, services, resources, content, or any other
              transactions made in connection with any third-party websites.
              Please review carefully the third-party's policies and practices
              and make sure you understand them before you engage in any
              transaction. You may not use third-party content without that
              third-party's permission, or as otherwise allowed by law.
              Complaints, claims, concerns, or questions regarding third-party
              products or services should be directed to the applicable
              third-party.
            </p>
          </div>

          <h6>
            <strong>3. Access to the Services</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>3.1. Creating an Account</em>
              </strong>
              <strong>.</strong> If you wish to participate in the Services you
              may be required to register for an account ("
              <strong>Account</strong>"). Please note, Company may have
              different types of accounts for different users such as, but not
              limited to seller, wholesale buyer, food hub, and individual
              buyer. It is up to you to determine which type of account is most
              appropriate for your individual needs. By creating an Account, you
              agree to (i) provide accurate, current, and complete registration
              information about yourself, (ii) maintain and promptly update as
              necessary your Account information, (iii) maintain the security of
              your password and accept all risks of unauthorized access to your
              Account and the information you provide us, and (iv) immediately
              notify us if you discover or otherwise suspect any security
              breaches related to the Services or your Account.
            </p>

            <p>
              <strong>
                <em>3.2. Account Responsibilities.</em>
              </strong>
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                <strong>
                  <em>3.2.1.</em>
                </strong>{" "}
                <u>Account Security; Notice of Unauthorized Use.</u> You are
                solely responsible for maintaining the confidentiality of your
                password and security of your Account. You are also entirely
                responsible for any and all activities associated with your
                Account. Your Account is personal to you and you agree not to
                provide any other person with access to the Services or any
                portions of it using your username, password, or other Account
                information. You agree to always maintain adequate security and
                control of all your Account details, passwords, personal
                identification numbers, or any other codes that you use to
                access the Services, including, by way of example, ensuring that
                you exit from your Account at the end of each session, using
                extra caution when accessing your Account from a public or
                shared computer so that others are not able to view or record
                your password or other personal information. You may not
                transfer your Account to anyone else without our prior written
                permission.
              </p>

              <p>
                You must notify Company immediately of any actual or suspected
                unauthorized breach of security, loss, theft, or unauthorized
                use of your Account, username, password, or other Account
                information at info@healthyplaneat.com The Company will not be
                liable for any losses or damages arising from your failure to
                comply with the above requirements. You will be held liable for
                losses or damages incurred by the Company or any third party due
                to someone else using your account or password.
              </p>

              <p>
                <strong>
                  <em>3.2.2.</em>
                </strong>{" "}
                <u>
                  User is Responsible for Equipment and Software to Connect to
                  Services.
                </u>{" "}
                You must provide all equipment and software necessary to connect
                to the Services, including, but not limited to, a mobile device
                that is suitable to connect with and use the Services, in cases
                where the Services offer a mobile component. You are solely
                responsible for any fees, including Internet connection or
                mobile fees, that you incur when accessing the Services.
              </p>
            </div>

            <p>
              <strong>
                <em>3.3. Company May Suspend Accounts</em>
              </strong>
              <strong>.</strong> Company reserves the right to terminate,
              suspend, or restrict your access to any Account(s) if (i) there is
              reasonable suspicion by us that the person logged into your
              Account(s) is not you, (ii) we discover you have created multiple
              Accounts for the same user, (iii) you buy, sell, rent, or lease
              access to your Account or username, (iv) you share your Account
              password with anyone, (v) you login or attempt to login to access
              your Account through an unauthorized third-party application or
              client, (vi) we suspect that the Account(s) have been or will be
              used for any illegal, fraudulent, or otherwise unauthorized
              purposes, or (vii) or your violation of this Agreement. Under no
              circumstances shall Company or other persons be responsible or
              liable for any direct, indirect, consequential, or other losses
              (including lost revenue, lost profits, lost business
              opportunities, loss of good will, or reputational harm), damages,
              or costs suffered by you or any other person or entity due to any
              such termination, suspension, or restriction of access to any
              Account(s).
            </p>

            <p>
              <strong>
                <em>3.4. Deletion of an Account</em>
              </strong>
              <strong>.</strong> You may delete your Account at any time, for
              any reason, by following the instructions on the Website. Company
              has the absolute and unrestricted authority to delete or modify
              inactive Accounts, at any time, with or without notice. Accounts
              that have not conducted any transactions on the Services for six
              (6) months may be deleted without notice.
            </p>

            <p>
              <strong>
                <em>3.5. Use Restrictions</em>
              </strong>
              <strong>.</strong> You agree to use the Services only for purposes
              that are legal, proper, and in accordance with this Agreement and
              any applicable laws or regulations. Without limitation, you may
              not, and may not allow, assist, or encourage any third-party to:
              (i) send, upload, distribute, or disseminate any unlawful,
              defamatory, harassing, abusive, fraudulent, obscene, or otherwise
              objectionable content; (ii) undertake any unlawful activity which
              would violate, or assist in violation of, any law, statute,
              ordinance, or regulation; (iii) distribute viruses, malware,
              spyware, adware, ransomware, worms, defects, Trojan horses,
              corrupted files, hoaxes, or any other items of a destructive,
              malicious, or deceptive nature; (iv) impersonate another person
              (via the use of an email address or otherwise); (v) upload, post,
              transmit, or otherwise make available through the Services any
              content that infringes the intellectual proprietary rights of any
              party; (vi) operate to defraud Company, other users, or any other
              person; (vii) provide false, inaccurate, or misleading
              information; (viii) use the Services to violate the legal rights
              (such as rights of privacy and publicity) of others; (ix) engage
              in, promote, or encourage illegal activity (including, without
              limitation, terrorism, tax evasion, or money laundering); (x)
              interfere with another individual's or entity's access to or use
              of the Services; (xi) defame, abuse, extort, harass, stalk,
              threaten others; (xii) incite, threaten, facilitate, promote, or
              encourage hate, racial intolerance, or violent acts against
              others; (xiii) harvest or otherwise collect information from the
              Services about others, including without limitation email
              addresses, without proper consent; (xiv) exploit the Services for
              any unauthorized commercial purpose; (xv) modify, create
              derivative works, adapt, translate, disassemble, reverse compile
              or reverse engineer any portion of the Services; (xvi) remove any
              copyright, trademark, or other proprietary rights notices
              contained in or on the Services or any part of it; (xvii) reformat
              or frame any portion of the Services; (xviii) display any content
              on the Services that contains any hate-related or violent content,
              or contains any other material, products, or services that violate
              or encourage conduct that would violate any criminal laws, any
              other applicable laws, or any third party rights; (xix) use any
              robot, spider, site search/retrieval application, or other device
              to retrieve, compile or index any portion of the Services or the
              content posted on the Services, or to collect information about
              its users, for any unauthorized purpose (including to create or
              compile a database, compilation, collection, or directory of
              content or data from the Services); provided, however, that
              Company conditionally grants to the operators of public search
              engines revocable permission to use spiders to copy materials from
              the Services for the sole purpose of, and solely to the extent
              necessary for, creating publicly available searchable indices of
              the materials, but not caches or archives of such materials; (xx)
              create user accounts by automated means, or under false or
              fraudulent pretenses; (xxi) access or use the Services for the
              purpose of creating a product or service that is competitive with
              any of our products or services; (xxii) send any unsolicited or
              unauthorized advertising, promotional materials, spam, junk mail,
              chain letters, or any other form of unsolicited communications,
              whether commercial or otherwise; or (xxiii) violate or otherwise
              circumvent the security of the Services in an attempt to gain
              unauthorized access to, or otherwise interfere with the proper
              working of, the Services or other systems or networks connected to
              the Services.
            </p>

            <p>
              <strong>
                <em>3.6. Communications</em>
              </strong>
              <strong>.</strong> Company may communicate with you using email,
              phone calls, chatbots and text messages, including autodialed or
              prerecorded calls and text messages, at any email address or
              telephone number that you provide us, to: (i) notify you regarding
              your Account; (ii) provide customer support; (iii) troubleshoot
              problems with your Account; (iv) resolve a dispute; (v) collect a
              debt; (vi) poll your opinions through surveys or questionnaires;
              or (vii) as otherwise necessary to service your Account or enforce
              this Agreement, our policies, applicable law, or any other
              agreement we may have with you.
            </p>

            <p>
              You agree that any notices, agreements, disclosures, or other
              communications that we send to you electronically will satisfy any
              legal communication requirements, including, but not limited to,
              that such communications be in writing. We may also send you
              promotional communications via email, including, but not limited
              to, newsletters, special offers, surveys, and other news and
              information we think will be of interest to you. You may opt out
              of receiving these promotional emails at any time by following the
              unsubscribe instructions provided therein.
            </p>
          </div>

          <h6>
            <strong>4. Policies for Using the Services</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>4.1. For Sellers Using the Services</em>
              </strong>
              <strong>.</strong> In addition to all other applicable terms and
              conditions in this Agreement and the Privacy Policy, the following
              obligations and restrictions set forth in this Section 4.1 apply
              to you if you are operating as a Seller.
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                <strong>
                  <em>4.1.1.</em>
                </strong>{" "}
                <u>What Can Be Sold</u>. The Services offer a unique marketplace
                for sustainable food from local farms. Seller represents and
                warrants that: (i) it qualifies as a small or midsize farm
                and/or food artisan; (ii) all produce is grown using
                environmentally sustainable growing practices; (iii) you have
                obtained and are current on all necessary federal, state, and
                local licenses and certifications to market your products to the
                Buyer (e.g., you must maintain and update your USDA organic
                certification); and (iv) the produce and/or products are
                available for delivery by you (or on your behalf) or for pick-up
                at your farm, farmers market, or pick-up location. You agree to
                upload to the Services your then-current USDA organic
                certificate and ensure an up to date version is maintained with
                Company at all times. Should any of the foregoing become untrue,
                you will immediately (within seventy-two (72) hours) notify
                Company in writing. Any produce and/or products that are not in
                compliance with the foregoing restrictions cannot be sold via
                the Services, and Company reserves the right to suspend or
                terminate any listings for non-compliance.
              </p>

              <p>
                <strong>
                  <em>4.1.2.</em>
                </strong>{" "}
                <u>Responsibility for Maintaining Quality.</u> Sellers have the
                responsibility for maintaining the quality of any produce and/or
                products sold. Accordingly, you represent and warrant that: (i)
                you possess the equipment and facilities necessary to maintain
                any produce and/or products (a) stored in your warehouse/storage
                facility and/or (b) delivered via your delivery vehicles (if
                applicable), so as to avoid any undue deterioration either in
                quality, shelf life or freshness; and (ii) you will maintain any
                produce and/or product sold to avoid any undue deterioration
                either in quality, shelf life or freshness.
              </p>

              <p>
                <strong>
                  <em>4.1.3.</em>
                </strong>{" "}
                <u>Representing Yourself Honestly.</u> We value transparency
                throughout the Services. This means that you will represent
                yourself, your company, and your produce and/or products
                accurately and honestly, including by ensuring accurate produce
                and/or product labeling. Additionally, you represent and warrant
                that you will not: (i) engage in fee avoidance; (ii) create
                multiple shops on our Services; or (iii) coordinate pricing with
                other Sellers.
              </p>

              <p>
                <strong>
                  <em>4.1.4.</em>
                </strong>{" "}
                <u>Seller Privacy and Protection of Personal Information.</u>{" "}
                You are responsible for protecting Buyers' personal information
                you receive or process, and you must comply with all applicable
                legal or industry requirements (e.g., PCI DSS). This includes
                applicable data protection and privacy laws that govern the ways
                in which you can access, store, use, and disclose Buyer
                information. For example, these laws may require that you post
                and comply with your own Privacy Policy, which must be
                accessible to the Buyer with whom you interact on our Services.
                In addition to any applicable legal or industry requirements,
                your Privacy Policy must be no less restrictive than this
                Agreement and our Privacy Policy. You are an independent
                controller of data relating to Buyers that you may have obtained
                through the Services.
              </p>

              <p>
                During the provision of your obligations related with the
                Services you may receive a Buyer's email address or other
                information as a result of entering into a transaction with that
                Buyer. Information shared between Buyer-Seller during the course
                of a transaction is not a part of the Services and Company
                disclaims any and all responsibility as it pertains to any claim
                brought by a third-party as a result. Such information disclosed
                during a Buyer-Seller transaction may only be used solely for
                provision of the Services, unless the Buyer otherwise authorizes
                you to use it for other purposes. For the avoidance of doubt,
                you may not use such transaction information (i) for unsolicited
                commercial messages or unauthorized transactions, (ii) to add
                any user of the Services to your email or physical mailing list,
                (iii) to use that Buyer's identity for any marketing or related
                purpose, or (iv) to obtain or retain any payment information,
                except as necessary for the purposes of facilitating the
                Buyer-Seller transaction. You acknowledge and agree that you are
                responsible for knowing the standard of consent required in any
                given instance.
              </p>

              <p>
                <strong>
                  <em>4.1.5.</em>
                </strong>{" "}
                <u>Seller Insurance.</u> Seller shall carry for the term of this
                Agreement and one (1) year thereafter, the following insurance
                coverages: (i) worker's compensation insurance in statutorily
                required amounts; (ii) commercial general and professional
                liability coverage, with limits of at least One Million Dollars
                ($1,000,000) per occurrence, and at least Two Million Dollars
                ($2,000,000) in annual aggregate; (iii) general automobile
                insurance, covering owned, non-owned and hired vehicles of at
                least One Million Dollars ($1,000,000) combined single limit;
                and (iv) umbrella insurance of no less than One Million Dollars
                ($1,000,000) in the aggregate. Such insurance policies: (a)
                shall be issued by an insurer licensed to practice in the state
                of residence or an insurer pre-approved by Company, such
                approval not to be unreasonably withheld. Seller shall provide
                Company with Certificates of Insurance evidencing ongoing
                compliance with this Section. Seller agrees to notify Company at
                least thirty (30) days before any lapse or reduction in
                coverage. Nothing contained in this Section shall be construed
                as limiting Seller's liability as set forth in this Agreement.
              </p>

              <p>
                <strong>
                  <em>4.1.6.</em>
                </strong>{" "}
                <u>Customer Service.</u> We expect you to provide the highest
                levels of customer service. By selling on the Services, you
                represent and warrant that you will:
              </p>

              <div style={{ marginLeft: "2em" }}>
                <p>
                  1) honor your stated delivery, shipping and processing times;
                  Sellers are obligated to deliver or ship an item or otherwise
                  complete a transaction with a Buyer in a prompt manner, unless
                  there is an exceptional or unforeseeable circumstance.
                </p>
                <p>2) respond to messages in a timely manner.</p>
                <p>
                  3) resolve disagreements or disputes directly with the Buyer.
                </p>
                <p>
                  4) if you are unable to complete an order, you must promptly
                  notify Buyer to either offer a substitute or cancel the order
                  and provide Buyer a refund of any paid fees.
                </p>
              </div>

              <p>
                <strong>
                  <em>4.1.7.</em>
                </strong>{" "}
                <u>Returns.</u> Each individual Seller may choose whether or not
                it accepts returns and exchanges, provided they must clearly
                communicate the relevant terms and conditions of its return and
                exchange policy, including, if applicable, the specific types of
                items Seller will accept returns and exchanges of. Seller agrees
                to comply at all times with its returns and exchange policy.
              </p>

              <p>
                <strong>
                  <em>4.1.8.</em>
                </strong>{" "}
                <u>Pick-up Events.</u> Sellers will have the ability through the
                Services to create pick-up location events (each a{" "}
                <strong>Pick-up Event</strong>), including setting such details
                as the day, time, location, and inviting other participating
                Sellers. The Seller organizing the Pick-up Event (
                <strong>Pick-up Event Host</strong>) acknowledges and agrees
                that (i) it shall be solely responsible for obtaining any
                consents required to host a Pick-up Event at a specific location
                (the <strong>Pick-up Event Location</strong>) and its compliance
                with any laws, regulations, or ordinances applicable to such
                Pick-up Event Location and (ii) Company is not liable for
                personal injury or property damages resulting from another
                party's access to or use of the Pick-up Event Location. The
                Pick-up Event Host represents and warrants that the Pick-up
                Event Location will be safe and free of any hazards.
                Additionally, all Sellers attending a Pick-up Event organized
                through the Services acknowledge and agree to comply with any
                additional instructions or obligations as may be communicated by
                Company. Pick-up Event Host agrees to indemnify, defend, and
                hold Company harmless from any and against all Claims (as
                defined in Section 14), arising out of or relating to personal
                injury, death, or damage to real or tangible personal property
                arising from or connected with the Pick-up Event or Pick-up
                Event Location.
              </p>
            </div>

            <p>
              <strong>
                <em>4.2. For Buyers Using the Services.</em>
              </strong>
              <strong> </strong>In addition to all other applicable terms and
              conditions in this Agreement and the Privacy Policy, the following
              obligations and restrictions set forth in this Section 4.2 apply
              to you if you are operating as a Buyer.
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                <strong>
                  <em>4.2.1.</em>
                </strong>{" "}
                <u>Understanding Who You Are Buying From.</u> The Services
                provide a venue for you to discover and purchase from Sellers,
                including for Distribution Providers to purchase from farmers,
                food artisans and other Distribution Providers. It is important
                to note that Company is not a part of that the transaction
                between a Buyer and Seller. By using the Services, you
                acknowledge and agree that:
              </p>

              <div style={{ marginLeft: "2em" }}>
                <p>
                  (i) you are not buying directly from Company, but from one of
                  the many talented Sellers on the Services.
                </p>
                <p>
                  (ii) while Company may elect to pre-screen Sellers, Company
                  does not represent, warrant, guarantee, or endorse any items
                  sold on the Website or any content posted by Sellers (such as
                  photographs or language used in listings or shop policies).
                </p>
                <p>
                  (iii) each Seller on the Services has their own processing
                  times, delivery times, shipping methods, and shop policies.
                  You should refer to Seller for this information.
                </p>
                <p>
                  (iv) the transaction between a Buyer and Seller is subject to
                  and governed by a separate sales agreement between Buyer and
                  Seller (e.g., Seller's terms and conditions).
                </p>
                <p>
                  (v) any disagreements or disputes with Seller will be resolved
                  directly with Seller.
                </p>
              </div>

              <p>
                <strong>
                  <em>4.2.2.</em>
                </strong>{" "}
                <u>Purchasing.</u> When you purchase through the Services, you
                are directly supporting an independent business, each with its
                unique listings, policies, processing times, and payment
                systems. By making a purchase on the Services, you agree that
                you have:
              </p>

              <div style={{ marginLeft: "2em" }}>
                <p>
                  (i) read the item description(s) and applicable Seller terms
                  and conditions before making a purchase.
                </p>
                <p>(ii) submitted appropriate payment for item(s) purchased.</p>
                <p>
                  (iii) provided accurate shipping and billing information to
                  the Seller.
                </p>
              </div>

              <p>
                You represent and warrant that you have all legal right to use
                all payment method(s) represented by any information relevant to
                your transaction, including your credit card number, the
                expiration date of your credit card, and postal address for
                billing.
              </p>

              <p>
                <strong>
                  <em>4.2.3.</em>
                </strong>{" "}
                <u>Returns.</u> You acknowledge that ALL SALES ARE FINAL and not
                eligible for returns, cancelations or refunds, unless an
                individual Seller has chosen (in its sole discretion) to accept
                returns and exchanges (pursuant to its communicated terms and
                conditions). In the event you are: (i) missing produce and/or
                products; or (ii) dissatisfied with the quality of your
                purchase, you agree to contact the Seller within forty-eight
                (48) hours of receipt.
              </p>
            </div>

            <p>
              <strong>
                <em>4.3. Third-Party Delivery Services</em>
              </strong>
              <strong>.</strong> The products on our Services may be available
              for delivery to Buyers via third-party delivery providers (
              <strong>Delivery Providers</strong>), including Sellers (e.g.,
              Distribution Providers may deliver products via refrigerated
              vehicles). In the event that you have a dispute with one or more
              Delivery Providers, you agree to address such dispute directly
              with such Delivery Providers and you release us and our
              affiliates, officers, directors, agents, investors, subsidiaries
              and employees from any and all claims, demands or damages (actual
              or consequential) of every kind and nature, known and unknown,
              suspected and unsuspected, disclosed and undisclosed, arising out
              of or in any way connected with such dispute. Buyer represents and
              warrants that: (i) the delivery location will be safe and free of
              any hazards; and (ii) Buyer has made others at the delivery
              location (e.g., security and staff) aware of the delivery and the
              Delivery Provider is authorized to access the delivery location.
              Buyer acknowledges that the Delivery Provider has the unilateral
              right to decide not to access the delivery location (e.g., if
              there are safety concerns). COMPANY IS NOT LIABLE FOR ANY DAMAGES
              OR LOSS CAUSED BY DELAYS. Delivery Providers will make
              commercially reasonable efforts to ensure delivery of goods are
              kept time and temperature safe; provided, however, you accept that
              such transportation of goods is at your own risk. Seller agrees to
              indemnify, defend, and hold Company harmless from any and against
              all Claims, arising out of or relating to personal injury, death,
              or damage to real or tangible personal property arising from or
              connected with the delivery services provided by Delivery
              Providers.
            </p>

            <p>
              <strong>
                <em>4.4. Fee Avoidance</em>
              </strong>
              <strong>.</strong> Any action by a Buyer or Seller to avoid paying
              fees is considered fee avoidance and it strictly prohibited. You
              agree that, during the period in which you have an Account and one
              (1) year thereafter, you will not, and will not permit your
              affiliates to, without the prior written consent of Company,
              directly or indirectly solicit, induce, encourage or otherwise
              knowingly cause (or attempt to do any of the foregoing) any person
              or entity, holding an Account on the Services as of the date of
              the relevant act prohibited by this Section 4.4 or during the one
              (1) year period preceding such date, to divert business from the
              Services in order to avoid paying fees. Activity that is in breach
              of this paragraph could result in a range of actions including,
              without limitation, buying and selling restrictions, Account
              suspension or termination, application of fees, and recovery of
              expenses for fee avoidance policy monitoring and enforcement. If
              you receive an offer from a Buyer or Seller (as applicable) to
              transact outside of the Services, please contact us directly. In
              the event you are suspected of fee avoidance in violation of this
              paragraph, Company will use commercially reasonable efforts to
              provide you with notice of any action to be taken hereunder, and,
              in Company's sole discretion, an opportunity to remedy such
              violation. If you believe such action hereunder has been made in
              error, and that you have not violated this paragraph, please
              contact us directly.
            </p>
          </div>

          <h6>
            <strong>5. Payment</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>5.1. Services Fees</em>
              </strong>
              <strong>.</strong> Every transaction on the Services is subject to
              fees collected to support the Services (
              <strong>Services Fees</strong>). Except as otherwise set forth in
              a mutually agreed upon ordering document for use of the Services
              (each, an <strong>Order</strong>), the Services Fees are detailed
              on the Services pricing page. The Service Fees are included in the
              price and payable and charged at the time of each transaction
              (i.e., you will pay at the time of the transaction).
            </p>

            <p>
              <strong>
                <em>
                  5.2. Company and Seller Reserve the Right to Refuse any Order
                </em>
              </strong>
              <strong>.</strong> All products are subject to Seller's
              availability. In the event Seller or Company needs to cancel your
              order, in whole or in part, Seller or Company (as applicable) will
              contact you directly via the information you provided with your
              order to discuss potential substitutions or refunds.
            </p>

            <p>
              <strong>
                <em>5.3. Payment Processors</em>
              </strong>
              <strong>.</strong> Company uses third-party providers (i.e.,
              Stripe) to process payments (<strong>Payment Processor</strong>').
              When making any payment using Stripe in relation to your use of
              the Services, you are subject to the Stripe{" "}
              <a href="https://stripe.com/legal/connect-account">
                Connected Account Agreement
              </a>
              , including the Stripe{" "}
              <a href="https://stripe.com/legal/ssa">Services Agreement</a>{" "}
              (collectively, the <strong>Stripe Services Agreement</strong>). By
              using the Services, you agree to be bound by the Stripe Services
              Agreement, as the same may be modified by Stripe from time to
              time. You expressly authorize Company or Payment Processor to
              charge you for each transaction. Payment Processor may ask you to
              supply additional information relevant to your transaction,
              including your credit card number, the expiration date of your
              credit card, and your email and postal addresses for billing and
              notification (such information,{" "}
              <strong>Payment Information</strong>). You will provide all
              Payment Information directly to our Payment Processor. You
              represent and warrant that you have the legal right to use all
              payment method(s) represented by any such Payment Information.
              When you initiate a transaction through the Services, you
              authorize our Payment Processor to complete your transaction, and
              to charge your payment method for the transaction (plus any
              applicable taxes and other charges). You may need to provide
              additional information to verify your identity before completing
              your transaction (such information is included within the
              definition of Payment Information). By initiating a transaction,
              you agree to the pricing, payment, and billing policies applicable
              to such fees and charges, as posted or otherwise communicated to
              you. All fees and applicable taxes, if any, are payable in United
              States dollars.
            </p>

            <p>
              <strong>
                <em>5.4. Cancelling Payment and Chargebacks</em>
              </strong>
              <strong>.</strong> You may only cancel a transaction pursuant the
              policies as communicated to you by us or by our Payment
              Processors. If you have any concerns or objections regarding
              charges, you agree to raise them with us first and you agree not
              to cancel or reject any credit card or third-party payment
              processing charges unless you have made a reasonable attempt at
              resolving the matter directly with Company. We may institute a
              chargeback policy as we deem appropriate in the event that you or
              your bank does not honor a payment obligation or if our Payment
              Processors question our ability to collect funds from you. As part
              of such chargeback policy, we may in our sole discretion suspend,
              terminate, or otherwise limit your ability to use the Services or
              otherwise take any action we or our Payment Processors deem
              necessary.
            </p>

            <p>
              <strong>
                <em>5.5. Taxes</em>
              </strong>
              <strong>.</strong> You are responsible to pay any and all sales,
              use, value-added, and other taxes, duties, and assessments now or
              hereafter claimed or imposed by any governmental authority,
              associated with your use of the Services.
            </p>
          </div>

          <h6>
            <strong>6. Intellectual Property Rights</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>6.1. Ownership of Intellectual Property</em>
              </strong>
              .
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                <strong>
                  <em>6.1.1.</em>
                </strong>{" "}
                You acknowledge that all content on the Services (including, for
                example, text, designs, graphics, logos, icons, images, audio
                clips, downloads, interfaces, information, code and software,
                and the selection and manner of compilation and presentation)
                (collectively, the <strong>Content</strong>) is owned by
                Company, its licensors, or other content providers of such
                material (as applicable), and may be protected by intellectual
                property rights, including copyrights, trademarks, trade
                secrets, patents, and other applicable laws. You shall not copy,
                reproduce, publish, display, perform, post, transmit, or
                distribute any part of the Content in any form or by any means
                except as expressly permitted herein or as enabled by a feature,
                product, or the Services when provided to you. Neither this
                Agreement nor your access to and use of the Services grants you
                any license, right, title, or interest in or to use any
                copyrighted materials or any trademark, logo, or service mark
                displayed on the Services. Company, our content providers, or
                our licensors (as applicable) retain full and complete title to
                and reserve all rights in the material on the Services,
                including all associated intellectual property rights. Company
                neither warrants nor represents that your use of materials on
                the Services will not infringe rights of third parties.
              </p>

              <p>
                <strong>
                  <em>6.1.2.</em>
                </strong>{" "}
                You may access the Services only for your permitted use under
                this Agreement, and you may not modify or delete any copyright,
                trademark, or other proprietary notice relating to any material
                you access. You agree not to display or use in any manner the
                Company marks without Company's advance written permission.
              </p>

              <p>
                <strong>
                  <em>6.1.3.</em>
                </strong>{" "}
                All software used on the Services is the property of Company or
                our licensors and protected by United States and international
                copyright laws, and subject to separate license terms, in which
                case those license terms will govern such software. You agree
                not to reproduce, duplicate, copy, sell, resell, or exploit any
                portion of the Services, use of the Services, or access to the
                Services or any contact on the website through which the
                Services are provided, without express written permission by us.
              </p>

              <p>
                <strong>
                  <em>6.1.4.</em>
                </strong>{" "}
                All rights not expressly granted in this Agreement are reserved
                by the Company and its affiliates, and licensors. You agree to
                abide by all additional restrictions displayed on the Services
                as they may be updated from time to time.
              </p>
            </div>

            <p>
              <strong>
                <em>6.2. Feedback to the Company</em>
              </strong>
              <strong>.</strong> If you provide the Company with any feedback,
              comments, questions, ideas, proposals, or suggestions regarding
              Company or any of the Services, whether online, by email, by
              postal mail, or otherwise (collectively, <strong>Feedback</strong>
              ), you represent and warrant (i) that you have the right to
              disclose the Feedback, (ii) that the Feedback does not violate the
              rights of any other person or entity, including, but not limited
              to, intellectual property rights, such as infringing a copyright,
              trademark, or patent; violating a right of privacy, attribution or
              withdrawal; or otherwise misappropriating a trade secret, and
              (iii) that your Feedback does not contain the confidential or
              proprietary information of any third party or parties. By sending
              us any Feedback, you further (1) agree that we are under no
              obligation of confidentiality, express or implied, with respect to
              the Feedback, (2) acknowledge that we may have something similar
              to the Feedback already under consideration or in development, and
              (3) irrevocably assign to Company all rights, title, and interest
              in such Feedback and agree that Company shall have the right to
              use and fully exploit such Feedback and related information,
              including derivative works, in any manner it deems appropriate. To
              the extent any such rights may be inalienable, you agree to waive
              and agree not to exercise such rights and, if such waiver and
              agreement are deemed invalid, to grant to Company the exclusive,
              perpetual, irrevocable, worldwide and royalty free right to use,
              market, and modify any such Feedback without any obligation of
              attribution or consent. Company will treat any Feedback that you
              provide to the Company as non-confidential and non-proprietary.
              You agree that you will not submit to the Company any information
              or ideas that you consider to be confidential or proprietary. This
              Feedback section shall survive any termination of your account or
              any aspect of the Services..
            </p>
          </div>

          <h6>
            <strong>7. User Content</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>7.1. User Generated Content</em>
              </strong>
              <strong>.</strong> The Services may contain message boards,
              chatrooms, profiles, forums, and other interactive features that
              allow users to post, upload, submit, publish, display, or transmit
              to other users or other persons content or materials
              (collectively, <strong>User Content</strong>) on or through the
              Services.
            </p>

            <p>
              You acknowledge and agree that you are solely responsible for your
              User Content that you submit or transmit to, through, or in
              connection with the Services or that you publicly display or
              displayed in your Account profile, and you, not Company, assume
              all risks associated with your User Content, including anyone's
              reliance on its quality, accuracy, reliability, appropriateness,
              or any disclosure by you of information in your User Content that
              makes you or anyone else personally identifiable. Please consider
              carefully what you choose to share. All User Content must comply
              with the Content Standards set forth below and the rest of this
              Agreement. You represent that you own or have the necessary
              rights, consents, and permissions to use and authorize the use of
              your User Content as described herein. You may not imply that your
              User Content is in any way sponsored or endorsed by Company. You
              represent and warrant that your User Content does not violate this
              Agreement or the rights of any third-party. You may not imply that
              User Content is in any way sponsored or endorsed by Company. Any
              User Content you post on or through the Services will be
              considered non-confidential and non-proprietary. Finally, you
              irrevocably waive, and cause to be waived, against Company and its
              users any claims and assertions of moral right or attribution with
              respect to your User Content. We are not and shall not be under
              any obligation, except as otherwise expressly set forth in this
              Agreement or our other policies (1) to maintain your User Content
              in confidence, (2) to pay you any compensation for your User
              Content or otherwise credit you for your User Content, (3) to
              display or accept your User Content, (4) to respond to your User
              Content, or (5) to exercise any of the rights granted herein with
              respect to your User Content.
            </p>

            <p>
              You agree that the Company shall not be responsible or liable to
              any third party for any User Content posted by you or any other
              user of the Services. You further agree that the Company shall not
              be responsible for any loss or damage incurred as the result of
              any interactions between you and other users. Your interactions
              with other users are solely between you and such users. If there
              is a dispute between you and any other user, we are under no
              obligation to become involved.
            </p>

            <p>
              <strong>
                <em>7.2. License</em>
              </strong>
              <strong>.</strong> You hereby grant to the Company an irrevocable,
              non-exclusive, royalty-free and fully paid, transferable,
              assignable, perpetual, and worldwide license to reproduce,
              distribute, publicly display and perform, prepare derivative works
              of, incorporate into other works, and otherwise use and exploit
              your User Content, and to grant sublicenses of the foregoing
              rights, in connection with the Services and the Company's business
              including, without limitation, for promoting and redistributing
              part or all of the Services in any media formats and through any
              media channels. By "use" in the preceding sentence we mean use,
              make, have made, sell, offer for sale, import, practice, copy,
              publicly perform, and display, reproduce, perform, distribute,
              modify, translate, remove, analyze, commercialize, and prepare
              derivative works of your User Content for any purpose. Please note
              that you also irrevocably grant the users of the Services the
              right to access your User Content in connection with their use of
              the Services.
            </p>

            <p>
              <strong>
                <em>7.3. User Content Standards</em>
              </strong>
              <strong>.</strong> You agree not to send, knowingly receive,
              upload, transmit, display, or distribute any User Content that
              does not comply with the following standards (
              <strong>Content Standards</strong>). User Content must not:
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                (i) <u>Violate Laws or Obligations</u>. Violate any applicable
                laws or regulations (including intellectual property laws and
                right of privacy or publicity laws), or any contractual or
                fiduciary obligations.
              </p>
              <p>
                (ii) <u>Promote Illegal Activity or Harm to Others.</u> Promote
                any illegal activity; advocate, promote, or assist any unlawful
                act; or create any risk of any harm, loss, or damage to any
                person or property.
              </p>
              <p>
                (iii) <u>Infringe Intellectual Property Rights.</u> Infringe any
                copyright, trademark, patent, trade secret, moral right, or
                other intellectual property rights of any other person.
              </p>
              <p>
                (iv){" "}
                <u>Defamatory, Abusive, or Otherwise Objectionable Material.</u>{" "}
                Contain any information or material that we deem to be unlawful,
                defamatory, libelous, invasive of another's privacy or publicity
                rights, abusive, threatening, harassing, harmful, violent,
                hateful, obscene, vulgar, profane, indecent, offensive,
                inflammatory, humiliating to other people (publicly or
                otherwise), or otherwise objectionable. This includes any
                information or material that we deem to cause annoyance,
                inconvenience, or needless anxiety, or be likely to upset,
                embarrass, alarm, or annoy another person.
              </p>
              <p>
                (v){" "}
                <u>
                  Promotion of Sexually Explicit Material or Discrimination.
                </u>{" "}
                Promote sexually explicit or pornographic material, violence, or
                discrimination based on race, sex, religion, nationality,
                disability, sexual orientation, or age.
              </p>
              <p>
                (vi) <u>Fraudulent Information or Impersonation.</u> Contain any
                information or material that is false, intentionally misleading,
                or otherwise likely to deceive any person including, without
                limitation, impersonating any person, or misrepresenting your
                identity or affiliation with any person or organization.
              </p>
            </div>

            <p>
              <strong>
                <em>7.4. Monitoring and Enforcement</em>
              </strong>
              . We reserve the right at all times, but are not obligated, to:
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                (i) take any action with respect to any User Content that we
                deem necessary or appropriate in our sole discretion, including,
                without limitation, if we believe that such User Content
                violates the Content Standards or any other provision in this
                Agreement, or creates liability for the Company or any other
                person. Such action may include reporting you to law enforcement
                authorities.
              </p>
              <p>
                (ii) remove or reject any User Content for any or no reason in
                our sole discretion.
              </p>
              <p>
                (iii) disclose any User Content, your identity, or electronic
                communication of any kind to satisfy any law, regulation, or
                government request, or to protect the rights or property of the
                Company or any other person.
              </p>
              <p>
                (iv) Terminate or suspend your access to all or part of the
                Services for any or no reason, including without limitation, any
                violation of this Agreement.
              </p>
            </div>

            <p>
              We do not review User Content before it is posted on or through
              the Services, and therefore cannot ensure prompt removal of
              questionable User Content. Accordingly, the Company and its
              affiliates, and their respective officers, directors, employees,
              contractors, or agents, assume no liability for any action or
              inaction regarding transmissions, communications, or content
              provided by any user or third party. The Company shall have no
              liability or responsibility to anyone for performance or
              non-performance of the activities described in this Section.
            </p>
          </div>

          <h6>
            <strong>
              8. Copyright Infringement Complaints Under the Digital Millennium
              Copyright Act
            </strong>
          </h6>

          <p>
            Company respects the intellectual property rights of others. It is
            our policy to respond promptly to any claim that content posted on
            the Services infringes the copyright or other intellectual property
            rights of any person. Company will use reasonable efforts to
            investigate notices of alleged infringement and will take
            appropriate action under the Digital Millennium Copyright Act (
            <strong>DMCA</strong>) and this Agreement, including removing or
            disabling access to content claimed to be infringing and/or
            terminating accounts and access to the Services.
          </p>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>8.1. The DMCA Process and Procedure</em>
              </strong>
              . The DMCA provides a process for a copyright owner to give
              notification to an online service provider concerning alleged
              copyright infringement. When an effective DMCA notification is
              received, the online service provider responds under this process
              by taking down the offending content. On taking down content under
              the DMCA, we will take reasonable steps to contact the user
              responsible for posting the removed content so that a
              counter-notification may be filed if applicable. On receiving a
              valid counter-notification, we generally restore the content in
              question, unless we receive notice from the DMCA notice provider
              that a legal action has been filed seeking a court order to
              restrain the alleged infringer from engaging in the infringing
              activity. Our Privacy Policy does not protect any information
              contained in any DMCA take-down notice or counter-notification. If
              you have any questions about your rights, copyright infringement
              or the notification and counter-notification process under the
              DMCA, we recommend that you speak with an attorney.
            </p>

            <p>
              <strong>
                <em>8.2. Filing a DMCA "Take Down" Notification</em>
              </strong>
              <strong>.</strong> If you are a copyright owner or an agent
              thereof and believe that any content on the Services infringes
              upon your copyrights, you may submit a take-down notification (
              <strong>Take-Down Notification</strong>) pursuant to the DMCA by
              providing us with the following information in writing (see 17
              U.S.C. § 512 for further detail):
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                (i) A physical or electronic signature of a person authorized to
                act on behalf of the owner of an exclusive right that is
                allegedly infringed;
              </p>
              <p>
                (ii) Identification of the copyrighted work claimed to have been
                infringed, or, if multiple copyrighted works, a representative
                list of such works at that site;
              </p>
              <p>
                (iii) Identification of the material that is claimed to be
                infringing or to be the subject of infringing activity and that
                is to be removed or access to which is to be disabled, and
                information reasonably sufficient to permit us to locate the
                material; **Providing URLs in the body of your DMCA notification
                is the best way to help us locate content quickly**
              </p>
              <p>
                (iv) Information reasonably sufficient to permit us to contact
                you (the complaining party), such as an address, telephone
                number, and electronic mail address at which you (the
                complaining party) may be contacted;
              </p>
              <p>
                (v) A statement that you (the complaining party) have a good
                faith belief that use of the material in the manner complained
                of is not authorized by the copyright owner, its agent, or the
                law;
              </p>
              <p>
                (vi) A statement that the information in the notification is
                accurate, and under penalty of perjury, that you (the
                complaining party) are authorized to act on behalf of the owner
                of an exclusive right that is allegedly infringed; and
              </p>
              <p>
                (vii) **(Optional) Provide information, if possible, sufficient
                to permit us to notify the user(s) who posted the content that
                allegedly contains infringing material.
              </p>
            </div>

            <p>
              <em>
                Any person who knowingly materially misrepresents that content
                or an activity is infringing or that any material or activity
                was removed or disabled by mistake or misidentification, shall
                be liable to us and possibly others for any damages, including
                costs and attorneys' fees incurred by us in removing or
                disabling access to the material or activity claimed to be
                infringing or in replacing the removed material or enabling
                access to it.
              </em>
            </p>

            <p>
              <strong>
                <em>
                  8.3. Responding to a DMCA Notice with a Counter-Notification
                </em>
              </strong>
              . We will take reasonable steps to promptly inform you if your
              content has been taken down upon receipt of an effective Take-Down
              Notification. If you believe that the content that was removed or
              to which access was disabled is not infringing, or that you have
              the authorization from the copyright owner or the copyright
              owner's agent or pursuant to the law, to use the material, you may
              send us a counter notification ("
              <strong>Counter Notification</strong>") containing the following
              information:
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>(i) Your physical or electronic signature;</p>
              <p>
                (ii) Identification of the material that has been removed or to
                which access has been disabled and the location at which the
                material appeared before it was removed or disabled;
              </p>
              <p>
                (iii) A statement that you have a good faith belief that the
                material was removed or disabled as a result of mistake or a
                misidentification of the material; and
              </p>
              <p>
                (iv) Your name, address, telephone number, and e-mail address, a
                statement that you consent to the jurisdiction of the U.S.
                district court in the state in which you reside (or the U.S.
                district court where our headquarters are located if your
                address is outside of the United States), and a statement that
                you will accept service of process from the person who provided
                notification of the alleged infringement to us.
              </p>
            </div>

            <p>
              You have ten (10) business days after receipt of a Take-Down
              Notification to send us an effective Counter Notification or the
              allegedly infringing material may not be restored.
            </p>

            <p>
              <em>
                Any person who knowingly materially misrepresents that material
                or activity is infringing or that any material or activity was
                removed or disabled by mistake or misidentification, shall be
                liable to us for any damages, including costs and attorneys'
                fees incurred by us in removing or disabling access to the
                material or activity claimed to be infringing or in replacing
                the removed material or enabling access to it.
              </em>
            </p>

            <p>
              <strong>
                <em>8.4. Where to Send a DMCA Request</em>
              </strong>
              <strong>.</strong> You must submit your DMCA Take-Down
              Notification and Counter Notifications to us by email.
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>Email Address: info@healthyplaneat.com</p>
              <p>Subject/Heading of Email: DMCA Take Down Notification</p>
            </div>

            <p>
              <strong>
                <em>8.5. DMCA Notices Must Comply with These Requirements</em>
              </strong>
              <strong>.</strong> Official DMCA Notices must provide{" "}
              <strong>all</strong> the information described above in order to
              be effective. If your DMCA Notice is ineffective, we may ignore it
              and have no obligation to remove the allegedly infringing content.
            </p>

            <p>
              <strong>
                <em>
                  8.6. Company has the Right to Remove Allegedly Infringing
                  Content
                </em>
              </strong>
              . Company reserves the right to remove any content that allegedly
              infringes another person's copyright or trademark rights, thereby
              restricting access to or visibility of the content on the Services
              and restricting the owner's ability to buy, sell, access, or view
              the content on the Services. All transactions involving the
              Services are conducted with the knowledge and assumption of the
              risk that the content may subsequently be removed from the
              Services because of a DMCA dispute or a user's violation of this
              Agreement. Company shall not be liable to a user of content that
              was subsequently taken down by Company pursuant to a valid
              Take-Down Notification or a determination of a user's violation of
              this Agreement.
            </p>

            <p>
              <strong>
                <em>
                  8.7. Company has the Right to Terminate Repeat Infringers'
                  Accounts
                </em>
              </strong>
              . Company implements a strict "repeat infringer" policy, which
              requires it to terminate a user's access to the Services,
              including terminating a user's Account if, under appropriate
              circumstances, the user is determined to be a repeat infringer.
              Company also reserves the right to restrict a user's Account for
              reasons other than copyright infringement, such as but not limited
              to, minting pornographic, obscene, or hateful content, or
              excessive or suspicious minting conduct. We may at any time,
              without prior notice and in our sole discretion, remove such
              material and/or terminate a user's Account for submitting such
              material in violation of this Agreement or for any other reason.
            </p>

            <p>
              <strong>
                <em>8.8. User Agrees to Cooperate with Company</em>
              </strong>
              <strong>.</strong> All users expressly agree to cooperate and
              timely respond to Company's investigations, requests, and
              inquiries related to DMCA disputes or allegations of infringement.
            </p>
          </div>

          <h6>
            <strong>9. Confidentiality</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>9.1. Definition.</em>
              </strong>{" "}
              The parties acknowledge that, in the course of performance under
              the Agreement, one party ("<strong>Disclosing Party</strong>") may
              intentionally or inadvertently disclose, deliver or permit access
              to by the other party ("<strong>Receiving Party</strong>") certain
              data, materials, methodologies, and information (in written, oral,
              and/or electronic format) that a reasonable person would
              understand to be secret, proprietary and/or confidential given the
              circumstances of the disclosure (collectively "
              <strong>Confidential Information</strong>"). Without limiting the
              generality of the foregoing, all commercial information/pricing
              between you and us is Confidential Information of Company.
            </p>

            <p>
              <strong>9.2. Confidentiality Obligations.</strong> Receiving Party
              shall hold all Confidential Information of Disclosing Party in the
              strictest confidence and shall not disclose or provide such
              Confidential Information to any third Party without the express
              written consent of Disclosing Party in each instance, except that
              Receiving Party may disclose or provide such Confidential
              Information to the officers, directors, employees, subcontractors
              and suppliers of Receiving Party whose duties justify a
              need-to-know such Confidential Information; who are notified of
              their burden of confidentiality; and in the case of those who are
              not officers, directors or employees of Receiving Party, who have
              signed a non-disclosure agreement containing restrictions, terms
              and conditions that are at least as restrictive as those set forth
              herein. In all events Receiving Party shall use the same level of
              care to protect the Confidential Information of Disclosing Party
              as Receiving Party uses to protect Receiving Party's own most
              confidential and sensitive information but not less than
              reasonable care. Receiving Party shall not make any use whatsoever
              of Confidential Information of Disclosing Party except such
              limited use as is required to perform Receiving Party's
              obligations under this Agreement.
            </p>

            <p>
              <strong>9.3. Exclusions.</strong> The obligations set forth in
              this Section shall not apply to Confidential Information which
              Receiving Party can demonstrate by reasonable written evidence:
              (i) is already, or otherwise becomes, generally known by third
              parties as a result of no act or omission of Receiving Party; (ii)
              subsequent to disclosure hereunder is lawfully received from a
              third Party having the right to disseminate the information and
              without restriction on disclosure; (iii) is generally furnished to
              others by Disclosing Party without restriction on disclosure; (iv)
              is independently developed by Receiving Party with written
              evidence of such independent development; or (v) is disclosed
              pursuant to a legal or administrative order, provided that
              Disclosing Party is given prior notice and a reasonable
              opportunity to object (with Receiving Party's assistance) to such
              disclosure.
            </p>
          </div>

          <h6>
            <strong>10. Termination</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>10.1. Termination</em>
              </strong>
              <strong>.</strong> This Agreement is effective unless and until
              terminated by either your or us. Company may suspend or terminate
              your access or rights to use the Services at any time, for any or
              no reason, in our sole discretion, and without prior notice,
              including for any breach of the terms of this Agreement. Upon
              termination of your Account, your right to access and use the
              Services will immediately cease. Company will not have any
              liability whatsoever to you or any third-party for any suspension
              or termination of your rights under this Agreement, including for
              termination of your Account or deletion of your User Content. If
              you have registered for an Account, you may terminate this
              Agreement at any time by contacting Company and requesting
              termination of your Account. If we terminate this Agreement or
              suspend or terminate your access to or use of the Services due to
              your breach of this Agreement or any suspected fraudulent,
              abusive, or illegal activity, then termination of this Agreement
              will be in addition to any other remedies we may have at law or in
              equity.
            </p>

            <p>
              <strong>
                <em>10.2. Effect of Termination</em>
              </strong>
              <strong>.</strong> Upon termination of this Agreement, any
              provisions that by their nature should survive termination shall
              remain in full force and effect, including, without limitation,
              ownership or intellectual property provisions, warranty
              disclaimers, indemnification, and limitations of liability.
              Termination of your access to and use of the Services shall not
              relieve you of any obligations arising or accruing prior to
              termination or limit any liability that you otherwise may have to
              Company or any third party. You understand that any termination or
              expiration of your access to and use of the Services, whether by
              you or us, may involve loss of access to information that you have
              posted on the Services or that is related to your Account,
              including deletion of your User Content associated with your
              Account from our databases, and you acknowledge that we will have
              no obligation to maintain any such information in our databases or
              to forward any such information to you or to any third-party.
            </p>
          </div>

          <h6>
            <strong>
              11. Assumption of Risk; Representations and Warranties; Quality
              Standards; Recall Procedures
            </strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>11.1. Assumption of Risk</em>
              </strong>
              <strong>.</strong> The information presented on or through the
              Services is made available for general information purposes only.
              The Company does not warrant the accuracy, completeness,
              suitability, or quality of any such information. Any reliance on
              such information is strictly at your own risk. Company disclaims
              all liability and responsibility arising from any reliance placed
              on such information by you or any other user to the Services, or
              by anyone who may be informed of any of its contents.
            </p>

            <p>
              We recommend that you place all perishables in your refrigerator
              to ensure the ingredients' integrity. The risk of loss and/or
              damage passes to you at the time of your receipt the goods. YOU
              ARE SOLELY RESPONSIBLE FOR, AND ASSUME ALL RISKS RELATED TO, THE
              PROPER AND SAFE PREPARATION (INCLUDING STORAGE, WASHING, AND
              COOKING), USE, AND CONSUMPTION OF ALL PRODUCTS ORDERED OR RECEIVED
              THROUGH THE SERVICE.
            </p>

            <p>
              YOU UNDERSTAND THAT FOOD ITEMS PROVIDED THROUGH THE SERVICE MAY
              CONTAIN SOME OR ALL OF THE EIGHT MAJOR ALLERGENS, AS DETERMINED BY
              THE US FOOD AND DRUG ADMINISTRATION, WHICH ARE WHEAT, EGG, SOY,
              MILK, TREENUTS, PEANUTS, FISH, AND SHELLFISH. YOU ARE SOLELY
              RESPONSIBLE FOR KNOWING ABOUT ANY FOOD ALLERGIES YOU MAY HAVE AND
              VERIFYING THE PRODUCTS AND THEIR CONTENTS BEFORE HANDLING,
              PREPARING, USING, OR CONSUMING SUCH PRODUCTS. COMPANY DOES NOT
              REPRESENT OR WARRANT THAT THE NUTRITION, INGREDIENT, ALLERGEN, AND
              OTHER PRODUCT INFORMATION ON OUR SITE IS ACCURATE OR COMPLETE
              SINCE THIS INFORMATION IS PROVIDED BY THE FARMS OR PRODUCERS AND
              NOT COMPANY.
            </p>

            <p>
              IF YOU HAVE A SPECIFIC DIETARY OR ALLERGIC CONCERN OR QUESTION
              ABOUT A PRODUCT, WE RECOMMEND THAT YOU DO NOT RELY SOLELY ON THE
              INFORMATION PRESENTED ON OUR WEBSITE AND THAT YOU CONSULT THE
              PRODUCT'S LABEL OR CONTACT COMPANY IN ORDER TO PROVIDE INFORMATION
              TO CONTACT THE FARM OR PRODUCER DIRECTLY
            </p>

            <p>
              <strong>
                <em>11.2. Seller Representation and Warranties</em>
              </strong>
              <strong>.</strong> Seller represents and warrants that all goods
              that Seller grows, provides, manufactures, processes, and/or
              packages under this Agreement shall be:
            </p>

            <div style={{ marginLeft: "2em" }}>
              <p>
                (i) grown, produced, packed, stored and shipped in accordance
                with all applicable laws, including all Food Laws. For purposes
                of this Agreement <strong>Food Laws</strong> means any
                applicable law, policy or procedure of the U.S. Food and Drug
                Administration ("FDA"), U.S. Dept. of Agriculture ("USDA"),
                Federal Trade Commission, State Departments of Agriculture, or
                other governmental authorities of the U.S. or any jurisdictions
                in the U.S., including but not limited to The Federal Food,
                Drug, and Cosmetic Act, as amended, ("FDCA"), the Fair Packaging
                and Labeling Act, as amended, and any other law or regulations
                relating to the growing, production, ingredients, manufacture,
                labeling, advertising, promotion, sale, or safety of the goods,
                including the common law of any U.S. state or territory, and, if
                applicable, The Safe Drinking Water and Toxic Enforcement Act of
                1986, as amended, promulgated by the State of California
                (commonly referred to as "Proposition 65").
              </p>
              <p>
                (ii) manufactured, grown, provided, processed, and packaged
                strictly in conformity with applicable sanitation standards,
                such as those set forth by the FDA, the USDA, and any state and
                local governmental agencies, having jurisdiction, and in any
                event, in suitable conditions so as to avoid any undue
                deterioration either in quality, shelf life or freshness.
              </p>
              <p>
                (iii) fit and wholesome for human consumption and shall meet all
                requirements of applicable statutes, rules, and regulations of
                the United States and any state or local government.
              </p>
              <p>
                (iv) grown, produced, packed, stored and shipped in accordance
                with all needed governmental, administrative and other
                approvals, licenses, permits and other authorizations and
                registrations necessary for the marketing, distribution and sale
                of its goods.
              </p>
            </div>

            <p>
              <strong>
                <em>11.3. Recall Procedures</em>
              </strong>
              <strong>.</strong> Seller is responsible for any recall related to
              its goods failing to comply (or allegedly failing to comply) with
              Food Laws or any laws relating to labeling, the ingredients or any
              contaminants contained therein. Seller will notify Company
              immediately (within 24 hours) of becoming aware of any recall and
              will promptly provide Company with all information reasonably
              requested regarding the recall. Seller agrees to indemnify,
              defend, and hold Company harmless from any and against all Claims,
              arising out of or relating to any recall of Seller's goods and
              from the breach of any of the warranties herein. Seller assumes
              all risk of loss due to asserted food safety issues contemplated
              by this provision and the representations and warranties set forth
              in this Agreement.
            </p>
          </div>

          <h6>
            <strong>12. Warranty Disclaimer</strong>
          </h6>

          <p>
            YOU EXPRESSLY AGREE THAT YOUR USE OF, OR INABILITY TO USE, THE
            SERVICES IS AT YOUR SOLE RISK. THE SERVICES AND ALL PRODUCTS AND
            SERVICES DELIVERED TO YOU THROUGH THE SERVICES ARE PROVIDED ON AN
            "AS-IS" AND "AS AVAILABLE" BASIS. TO THE MAXIMUM EXTENT PERMITTED BY
            APPLICABLE LAW, COMPANY AND ITS OFFICERS, EMPLOYEES, DIRECTORS,
            SHAREHOLDERS, PARENTS, SUBSIDIARIES, AFFILIATES, AGENTS, AND
            LICENSORS DISCLAIM ALL WARRANTIES, CONDITIONS, AND REPRESENTATIONS
            OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE,
            INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET
            ENJOYMENT, ACCURACY, NON-INFRINGEMENT, AND THOSE ARISING OUT OF
            COURSE OF DEALING OR USAGE OF TRADE.
          </p>

          <p>
            TO THE EXTENT PERMITTED BY APPLICABLE LAW, COMPANY AND ITS
            AFFILIATES AND LICENSORS MAKE NO WARRANTIES THAT (i) THE SERVICES OR
            THE CONTENT PROVIDED THROUGH THE SERVICES IS ACCURATE, RELIABLE,
            COMPLETE, OR CORRECT; (ii) THAT THE RESULTS THAT MAY BE OBTAINED
            FROM THE USE OF THE SERVICE WILL BE ACCURATE OR RELIABLE; (iii) THAT
            THE SERVICES WILL BE AVAILABLE AT ANY PARTICULAR TIME OR LOCATION,
            UNINTERRUPTED, ERROR-FREE, OR SECURE; (iv) THAT ANY DEFECTS OR
            ERRORS WILL BE CORRECTED; (v) THAT THE SERVICES ARE FREE OF ANY
            WORMS OR VIRUSES OR ANY CODE OF A MALICIOUS AND/OR DESTRUCTIVE
            NATURE; OR (vi) THAT THE SERVICES, INFORMATION, OR ITEMS PURCHASED
            OR OBTAINED BY YOU THROUGH THE SERVICES WILL OTHERWISE MEET YOUR
            REQUIREMENTS OR EXPECTATIONS. YOU (AND NOT COMPANY) ASSUME THE
            ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR, OR CORRECTION.
          </p>

          <p>
            TO THE FULLEST EXTENT PROVIDED BY LAW, COMPANY AND ITS AFFILIATES
            WILL NOT BE LIABLE FOR ANY (i) ERRORS, MISTAKES, OR INACCURACIES OF
            CONTENT; (ii) PERSONAL INJURY OR PROPERTY DAMAGE RESULTING FROM YOUR
            ACCESS TO OR USE OF THE SERVICES OR CONSUMPTION OF ANY CONTENT;
            (iii) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SERVERS OR OF ANY
            PERSONAL INFORMATION OR USER DATA; (iv) ANY INTERRUPTION OF
            TRANSMISSION TO OR FROM THE SERVICES; (v) ANY BUGS, VIRUSES, TROJAN
            HORSES OR THE LIKE WHICH MAY BE TRANSMITTED ON OR THROUGH THE
            SERVICES; (vi) ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT
            OF THE USE OF ANY CONTENT POSTED OR SHARED THROUGH THE SERVICES; OR
            (vii) LOSS OR DAMAGED CAUSED BY ANOTHER USER'S VIOLATION OF THESE
            TERMS OF SERVICE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME
            RESPONSIBILITY FOR ANY PRODUCT OR SERVICES ADVERTISED OR OFFERED BY
            A THIRD PARTY THROUGH THE SERVICES OR THIRD-PARTY LINKS, AND WE WILL
            NOT BE A PARTY TO OR IN ANY WAY MONITOR ANY TRANSACTION BETWEEN YOU
            AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES OR ANY OTHER
            USER.
          </p>

          <p>
            THE SERVICES WOULD NOT BE PROVIDED WITHOUT THESE LIMITATIONS. NO
            ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM
            US THROUGH THE SERVICES SHALL CREATE ANY WARRANTY, REPRESENTATION,
            OR GUARANTEE NOT EXPRESSLY STATED IN THIS AGREEMENT. SOME
            JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO
            THE ABOVE EXCLUSION MAY NOT APPLY TO YOU. TO THE EXTENT WE MAY NOT,
            AS A MATTER OF APPLICABLE LAW, DISCLAIM ANY IMPLIED WARRANTY OR
            LIMIT OUR LIABILITIES, THE SCOPE AND DURATION OF SUCH WARRANTY AND
            THE EXTENT OF OUR LIABILITY WILL BE THE MINIMUM PERMITTED BY
            APPLICABLE LAW.
          </p>

          <h6>
            <strong>13. Limitation of Liability</strong>
          </h6>

          <p>
            TO THE FULLEST EXTENT ALLOWED BY APPLICABLE LAW, IN NO EVENT SHALL
            COMPANY AND ITS AFFILIATES, LICENSORS, SERVICE PROVIDERS, EMPLOYEES,
            AGENTS, CONTRACTORS, REPRESENTATIVES, SUPPLIERS, OFFICERS, OR
            DIRECTORS BE RESPONSIBLE FOR ANY LOSS, INCLUDING, WITHOUT
            LIMITATION, ANY LOSS OF USE, REVENUE, OR PROFIT, LOSS OF BUSINESS OR
            ANTICIPATED SAVINGS, LOSS OF DATA, LOSS OF GOODWILL, OR DIMINUTION
            IN VALUE, OR FOR ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY,
            SPECIAL, OR PUNITIVE DAMAGES, AND WHETHER ARISING OUT OF BREACH OF
            CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE, REGARDLESS OF
            WHETHER SUCH DAMAGE WAS FORESEEABLE AND WHETHER OR NOT THE COMPANY
            HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. YOUR SOLE
            REMEDY FOR DISSATISFACTION WITH THE SERVICES IS TO STOP USING THE
            SERVICES.
          </p>

          <p>
            NOTWITHSTANDING ANYTHING TO THE CONTRARY HEREIN, IN NO EVENT SHALL
            THE MAXIMUM TOTAL LIABILITY OF COMPANY AND ITS AFFILIATES, FOR ANY
            CLAIMS ARISING OUT OF OR IN ANY WAY RELATED TO THIS AGREEMENT OR THE
            ACCESS TO AND USE OF THE SERVICES, EXCEED THE LESSER OF (i) $100 OR
            (ii) TO THE TOTAL AMOUNT YOU PAID TO COMPANY IN FEES OVER THE SIX
            (6) MONTHS IMMEDIATELY PRECEDING THE CLAIM.
          </p>

          <p>
            SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
            CERTAIN DAMAGES, SO THE ABOVE LIMITATION AND EXCLUSIONS MAY NOT
            APPLY TO YOU. TO THE EXTENT WE MAY NOT, AS A MATTER OF APPLICABLE
            LAW, LIMIT OUR LIABILITIES, THE EXTENT OF OUR LIABILITY WILL BE THE
            MINIMUM PERMITTED BY APPLICABLE LAW.
          </p>

          <h6>
            <strong>14. Indemnification</strong>
          </h6>

          <p>
            You agree to indemnify, defend, and hold harmless Company and its
            officers, directors, employees, contractors, representatives,
            agents, affiliates, licensors, service providers, successors, and
            permitted assigns (collectively, "<strong>Indemnified Party</strong>
            ") from and against any and all losses, claims, actions, suits,
            complaints, investigations (whether formal or informal),
            proceedings, damages, liabilities, penalties, interest, judgments,
            settlements, deficiencies, disbursements, awards, fines, costs,
            fees, or expenses of whatever kind, including reasonable attorneys'
            fees, fees and other costs of enforcing any right to indemnification
            under this Agreement, and the cost of pursuing any insurance
            providers (each a "<strong>Claim</strong>" and collectively, the "
            <strong>Claims</strong>"), arising out of or relating to (1) any
            actual or alleged breach of this Agreement or the documents they
            incorporate by reference by you, a co-conspirator, or anyone using
            your Account, (2) or your use or misuse of the Services, (3) your
            violation of (i) any law or regulation, or (ii) the rights of a
            third-party, (4) your supply of products or services in connection
            with the Services, (5) User Content that (i) violates,
            misappropriates, or infringes upon a copyright, slogan, trademark,
            trade dress, patent, right of privacy, right of publicity, name,
            likeness, or any other proprietary or intellectual property right,
            or (ii) is untrue, fraudulent, offensive, misleading or otherwise
            unlawful, and (6) any dispute or issue between you and any
            third-party, including without limitation any Buyer or Seller (as
            applicable).
          </p>

          <p>
            In the event of a Claim, we will attempt to provide you notice of
            the Claim to the contact information we have for your Account/on
            file (provided that, failure to deliver such notice shall not
            eliminate or reduce your indemnification obligations hereunder).
            Company reserves the right, at your expense, to assume the exclusive
            defense and control of any matter for which you are required to
            indemnify us, and you agree to assist and cooperate with our defense
            or settlement of these claims. You agree that the provisions in this
            Section will survive any termination of your Account, this Agreement
            or your access to the Services, including the purchase or use of any
            benefits through the Services.
          </p>

          <h6>
            <strong>15. Dispute Resolution</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>15.1. Mandatory Arbitration of Disputes</em>
              </strong>
              <strong>.</strong> We each agree that any dispute, claim, or
              controversy arising out of or relating to this Agreement or the
              breach, termination, enforcement, interpretation or validity
              thereof or the use of the Services (collectively, "
              <strong>Disputes</strong>") will be resolved solely by binding,
              individual arbitration and not in a class, representative or
              consolidated action or proceeding. You and Company agree that the
              U.S. Federal Arbitration Act governs the interpretation and
              enforcement of this Agreement, and the laws of the state of
              Connecticut shall apply to the resolution of all Disputes,
              irrespective of any choice of law principles. YOU ACKNOWLEDGE AND
              UNDERSTAND THAT YOU AND COMPANY ARE EACH WAIVING THE RIGHT TO A
              TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION.
            </p>

            <p>
              <strong>
                <em>15.2. Exceptions</em>
              </strong>
              <strong>.</strong> As limited exceptions to Section 15.1 above:
              (i) we both may seek to resolve a Dispute in small claims court
              where you live or where Company is located (if it qualifies); and
              (ii) we each retain the right to seek injunctive or other
              equitable relief from a court to prevent (or enjoin) the
              infringement or misappropriation of our respective intellectual
              property rights.
            </p>

            <p>
              <strong>
                <em>15.3. Conducting Arbitration and Arbitration</em>
              </strong>{" "}
              <strong>Rules.</strong> The arbitration will be conducted by the
              American Arbitration Association ("<strong>AAA</strong>") in
              accordance with the AAA Consumer Arbitration Rules (the "
              <strong>AAA Rules</strong>") then in effect. The AAA Rules are
              available at{" "}
              <a href="https://www.adr.org/Rules">https://www.adr.org/Rules</a>{" "}
              and general information on the AAA process is found at
              www.adr.org. Information on how to initiate the arbitration is
              found at that website. The arbitration shall be, if possible,
              conducted either on the basis of documents or remotely. If an
              in-person hearing is necessary, the location of the arbitration
              will be in New Haven, Connecticut. The language to be used in the
              arbitration will be English. In all Disputes there shall be one
              (1) arbitrator. The arbitrator shall be appointed pursuant to the
              provisions for appointing an arbitrator in the AAA Rules. The
              arbitrator shall issue a decision in writing, briefly explaining
              the reasons therefor, and may award remedies that are available at
              law or in equity (so long as consistent with all of this
              Agreement. Please be advised that this Agreement contains certain
              limitations on the type and amount of damages that may be
              awarded). The arbitrator shall have no power to amend or
              supplement this Agreement to award damages other than as permitted
              herein, or to fail to follow applicable laws and regulations. Any
              award rendered by the arbitrator shall be final and binding on the
              parties, and may be confirmed by the judgment of a court of
              competent jurisdiction. This arbitration provision shall survive
              termination of this Agreement/Privacy Policy.
            </p>

            <p>
              <strong>
                <em>15.4. Arbitration Costs</em>
              </strong>
              <strong>.</strong> Payment of all filing, administration and
              arbitrator fees will be governed by the AAA Rules, and each party
              shall bear its own costs and expenses of arbitration, including
              legal fees.
            </p>

            <p>
              <strong>
                <em>15.5. Injunctive and Declaratory Relief</em>
              </strong>
              . Except as provided in Section 15.2 above, the arbitrator shall
              determine all issues of liability on the merits of any claim
              asserted by either party and may award declaratory or injunctive
              relief only in favor of the individual party seeking relief and
              only to the extent necessary to provide relief warranted by that
              party's individual claim. To the extent that you or we prevail on
              a claim and seek public injunctive relief (that is, injunctive
              relief that has the primary purpose and effect of prohibiting
              unlawful acts that threaten future injury to the public), the
              entitlement to and extent of such relief must be litigated in a
              civil court of competent jurisdiction and not in arbitration. The
              parties agree that litigation of any issues of public injunctive
              relief shall be stayed pending the outcome of the merits of any
              individual claims in arbitration.
            </p>

            <p>
              <strong>
                <em>15.6. Class Action Waiver</em>
              </strong>
              . YOU AND COMPANY AGREE THAT EACH PARTY MAY BRING CLAIMS AGAINST
              THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A
              PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE
              PROCEEDING. Further, if the parties' Dispute is resolved through
              arbitration, the arbitrator may not consolidate another person's
              claims with your claims, and may not otherwise preside over any
              form of a representative or class proceeding. If this specific
              provision is found to be unenforceable, then the entirety of this
              Dispute Resolution section shall be null and void.
            </p>

            <p>
              <strong>
                <em>15.7. Limitation to Time to File Claims</em>
              </strong>
              <strong>.</strong> ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE
              ARISING OUT OF OR RELATING TO THIS AGREEMENT OR THE SERVICES MUST
              BE COMMENCED WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION AROSE;
              OTHERWISE, SUCH CAUSE OF ACTION OR CLAIM IS PERMANENTLY WAIVED AND
              BARRED.
            </p>
          </div>

          <h6>
            <strong>16. Miscellaneous</strong>
          </h6>

          <div style={{ marginLeft: "2em" }}>
            <p>
              <strong>
                <em>16.1. Children</em>
              </strong>
              <strong>.</strong> Company's Services are directed at a general
              audience over the age of eighteen (18) and are not intentionally
              targeted to children. We do not knowingly collect or solicit
              personally identifiable information from a child under the age of
              thirteen (13) ("<strong>Child</strong>" or "
              <strong>Children</strong>") without obtaining verifiable consent
              from that Child's parent or guardian ("
              <strong>Parental Consent</strong>"), except for the limited amount
              of personally identifiable information we need to collect in order
              to obtain Parental Consent ("<strong>Required Information</strong>
              "). Until we have received Parental Consent, we will only use
              Required Information for the purpose of obtaining Parental
              Consent. If you are under thirteen (13) years old, please do not
              attempt to send any personal information about yourself to us
              before we obtain Parental Consent, except for the Required
              Information in the context of the Parental Consent process. If you
              are a parent or guardian and believe that your Child has provided
              us with personal information (beyond the Required Information)
              without our obtaining Parental Consent, please contact us.
            </p>

            <p>
              <strong>
                <em>16.2. Waiver</em>
              </strong>
              . Except as otherwise set forth in this Agreement, no failure of
              Company to exercise, or delay by Company in exercising, any right,
              remedy, power, or privilege arising from this Agreement shall
              operate or be construed as a waiver thereof, nor shall any single
              or partial exercise of any right, remedy, power, or privilege
              hereunder preclude any other or further exercise thereof or the
              exercise of any other right, remedy, power, or privilege.
            </p>

            <p>
              <strong>
                <em>16.3. Severability</em>
              </strong>
              . If any term or provision of this Agreement is found by a court
              of competent jurisdiction to be invalid, illegal, or
              unenforceable, then such term or provision shall nonetheless be
              enforceable to the fullest extent permitted by applicable law, and
              the unenforceable portion shall be deemed to be severed from this
              Agreement; such invalidity, illegality, or unenforceability shall
              not affect any other term or provision of this Agreement or
              invalidate or render unenforceable such term or provision in any
              other jurisdiction.
            </p>

            <p>
              <strong>
                <em>16.4. Entire Agreement</em>
              </strong>
              . This Agreement and any policies or operating rules posted by us
              on this Website or in respect to the Services, together with all
              documents referenced herein, constitutes the entire agreement
              between you and Company with respect to the subject matter
              contained herein. This Agreement supersedes all prior and
              contemporaneous understandings, agreements, representations, and
              warranties, both written and oral, with respect to the subject
              matter hereof (including, but not limited to, any prior versions
              of the Agreement). Any ambiguities in the interpretation of this
              Agreement shall not be construed against the drafting party.
            </p>

            <p>
              <strong>
                <em>16.5. Headings</em>
              </strong>
              <strong>.</strong> Headings and titles of sections, clauses, and
              parts in this Agreement are for convenience only. Such headings
              and titles shall not affect the meaning of any provisions of the
              Agreement.
            </p>

            <p>
              <strong>
                <em>16.6. No Agency, Partnership or Joint Venture</em>
              </strong>
              <strong>.</strong> No agency, partnership, or joint venture has
              been created between you and Company as a result of this
              Agreement. You do not have any authority of any kind to bind
              Company in any respect whatsoever.
            </p>

            <p>
              <strong>
                <em>16.7. Assignment</em>
              </strong>
              <strong>.</strong> You may not assign this Agreement to any other
              party. We may assign this Agreement or delegate any or all of our
              rights and responsibilities under this Agreement to any third
              parties, without notice to you. Subject to the limits on
              assignment stated above, this Agreement will inure to the benefit
              of, be binding on, and be enforceable against each of the parties
              hereto and their respective successors and assigns.
            </p>

            <p>
              <strong>
                <em>16.8. Export Laws &amp; Affiliation</em>
              </strong>
              . The Services may be subject to U.S. export control laws and
              regulations. To the extent applicable, you agree to abide by these
              laws and their regulations (including, without limitation, the
              Export Administration Act and the Arms Export Control Act) and not
              to transfer, by electronic transmission or otherwise, any
              materials from the Services to either a foreign national or a
              foreign destination in violation of such laws or regulations.
              Company has no affiliation with any certifications or certifying
              bodies.
            </p>

            <p>
              <strong>
                <em>16.9. Changes to this Agreement</em>
              </strong>
              <strong>.</strong> Company reserves the right, at our sole
              discretion, to update, change, modify, or replace any part of this
              Agreement by posting updates and changes to the Website. We may
              elect to notify you of such changes by mail, email, posting of a
              modified Agreement, or some other similar manner. In the event of
              any material changes to the Agreement, you will be prompted to
              click on "accept" or "agree" to this Agreement. However, it is
              your responsibility to check the Website regularly for changes to
              this Agreement. Your continued use of or access to the Services
              following the posting of any changes to this Agreement shall
              constitute your acknowledgment and acceptance of such changes.
            </p>
          </div>

          <h6>
            <strong>17. Contact Information</strong>
          </h6>

          <p>
            All notices, feedback, comments, requests for technical support, and
            other communications relating to this Agreement should be directed
            to info@healthyplaneat.com.
          </p>
        </div>
      </Container>
    </div>
  );
}

export default TermsOfUse;
